













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ExplorerButton extends Vue {
  @Prop() private title!: string;
  @Prop() private subtitle!: string;
  @Prop() private imageClass!: string;
  @Prop() private linkTo!: string;

  private styleClasses = `bullet ${this.imageClass}`; //md-xsmall-hide`;

  private navigate() {
    this.$router.push(this.linkTo);
  }
}
